import { persistReducer, persistStore } from "redux-persist";
import { persistConfig } from "./config";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducer";
import { caseMiddleware } from "./case";
import { clipMiddleware } from "./clip";
import { exportCommitMiddleware } from "./exportCommit";
import { glimpseMiddleware } from "./glimpse";
import { licenseMiddleware } from "./license";
import { noiseFilterMiddleware } from "./noiseFilter";
import { multiFileSelectMiddleware } from "./multiFileSelect";
import { userMiddleware } from "./user";
import { usersMiddleware } from "./users";
import { uploadQueueMiddleware } from "./uploadQueue";

const pReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: pReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          "persist/PERSIST",
          "persist/REHYDRATE",
          "uploadQueue/addFiles/pending",
          "uploadQueue/addFiles/fulfilled",
          "uploadQueue/removeFile",
          "uploadQueue/uploadChunk",
          "EDITOR_ADD_REGION",
        ],
        ignoredPaths: ["uploadQueue.files"],
      },
      immutableCheck: {
        ignoredPaths: ["uploadQueue.files", "editor.regions"],
      },
    })
      .concat(caseMiddleware)
      .concat(clipMiddleware)
      .concat(exportCommitMiddleware)
      .concat(glimpseMiddleware)
      .concat(licenseMiddleware)
      .concat(multiFileSelectMiddleware)
      .concat(noiseFilterMiddleware)
      .concat(uploadQueueMiddleware)
      .concat(userMiddleware)
      .concat(usersMiddleware),
});

export const persistor = persistStore(store);
